/****************************************************
 * Module Name:  employeeProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class EmployeeProxy {
  static GetAllEmployeeDetail = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/detail/employe/detail`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleEmployeeById = (employeId, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/detail/employe/${employeId}/detail`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateEmployee = (employeid, employeData, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/detail/employe/${employeid}/detail`,
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(employeData),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };


  static GetAllBrokerCustomerForEmployee = (employeeid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/mamangeprofile/${employeeid}/detail`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetCustomerPotentialSellDetails = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/reassign/customer/detail`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetUnassignedCustomerPotentialSellDetails = (employeeid, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/unassigned/customer/${employeeid}/detail`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static ReassignCustomer = (employeData, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/reassign/customer`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(employeData),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
